import _classCallCheck from "C:\\DC_L\\project\\tone-the-ear\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\DC_L\\project\\tone-the-ear\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import * as Util from './Util';

var Note =
/*#__PURE__*/
function () {
  _createClass(Note, null, [{
    key: "fromJSON",

    /**
     * Convert JSON to Note object
     * @param {object} json
     * @static
     * @returns {Note}
     */
    value: function fromJSON(json) {
      var note = new Note(json.midi, json.time, json.duration, json.velocity);
      return note;
    }
  }]);

  function Note(midi, time) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var velocity = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, Note);

    /**
     * The MIDI note number
     * @type {Number}
     */
    if (Util.isNumber(midi)) {
      this.midi = midi;
    } else if (Util.isPitch(midi)) {
      this.name = midi;
    } else {
      throw new Error('the midi value must either be in Pitch Notation (e.g. C#4) or a midi value');
    }
    /**
     * The note on time in seconds
     * @type {Number}
     */


    this.time = time;
    /**
     * The duration in seconds
     * @type {Number}
     */

    this.duration = duration;
    /**
     * The velocity 0-1
     * @type {Number}
     */

    this.velocity = velocity;
  }
  /**
   * If the note is the same as the given note
   * @param {String|Number} note
   * @return {Boolean}
   */


  _createClass(Note, [{
    key: "match",
    value: function match(note) {
      if (Util.isNumber(note)) {
        return this.midi === note;
      } else if (Util.isPitch(note)) {
        return this.name.toLowerCase() === note.toLowerCase();
      }
    }
    /**
     * The note in Scientific Pitch Notation
     * @type {String}
     */

  }, {
    key: "toJSON",

    /**
     * Convert the note to JSON
     * @returns {Object}
     */
    value: function toJSON() {
      return {
        name: this.name,
        midi: this.midi,
        time: this.time,
        velocity: this.velocity,
        duration: this.duration
      };
    }
  }, {
    key: "name",
    get: function get() {
      return Util.midiToPitch(this.midi);
    },
    set: function set(name) {
      this.midi = Util.pitchToMidi(name);
    }
    /**
     * Alias for time
     * @type {Number}
     */

  }, {
    key: "noteOn",
    get: function get() {
      return this.time;
    },
    set: function set(t) {
      this.time = t;
    }
    /**
     * The note off time
     * @type {Number}
     */

  }, {
    key: "noteOff",
    get: function get() {
      return this.time + this.duration;
    },
    set: function set(time) {
      this.duration = time - this.time;
    }
  }]);

  return Note;
}();

export { Note };